import { Injectable } from '@angular/core';

const STORAGE_KEY = 'forms_data';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor() {
    if (!this.isReload()) {
      this.clearAll();
    }
  }

  clearAll(): void {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  save<T>(key: string, data: T): void {
    const allData = this.getAllData();
    allData[key] = data;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(allData));
  }

  remove(key: string): void {
    const allData = this.getAllData();
    delete allData[key];
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(allData));
  }

  getData<T>(key: string): T | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      return parsed[key] as T;
    } catch (err) {
      return null;
    }
  }

  private getAllData(): Record<string, unknown> {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    try {
      return raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
    } catch {
      return {};
    }
  }

  private isReload(): boolean {
    if (performance?.getEntriesByType) {
      const navEntries = performance.getEntriesByType(
        'navigation'
      ) as PerformanceNavigationTiming[];
      if (navEntries.length > 0) {
        return navEntries[0].type === 'reload';
      }
    }

    // Fallback for older browsers
    return performance?.navigation?.type === 1;
  }
}
